import React from 'react';

import LocalStorage from '../../../shared/localStorage/LocalStorage';
import { LoginModel, loginModelInitial } from '../../../Models/LoginModel';

export function useProvideAuth() {

    function getLogin(): LoginModel {
        const login = LocalStorage.getItem('login');
        if (login)
            return login;
        else
            return loginModelInitial;
    }
    
    const [login, setLogin] = React.useState(getLogin());

    const signin = (login: LoginModel, cb: () => void) => {  
        LocalStorage.setItem('login', login);                 
        setLogin(login);
        cb();            
    };

    const signout = (cb: () => void) => {    
        LocalStorage.removeItem('login');       
        setLogin(loginModelInitial);
        cb();            
    };

    return {
        login,
        signin,
        signout
    };
}        